module.exports = __webpack_public_path__ + "b9b1faac13a74e4ef15b6c9febce4d73.svg";